"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Summaries = exports.toolsInstallDescription = exports.TelemetryDevCertStatus = exports.TelemetryDepsCheckStatus = exports.TelemetryProperties = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const localizeUtils_1 = require("../../../common/localizeUtils");
exports.TelemetryProperties = Object.freeze({
    driverArgs: "driver-args",
    devCertStatus: "dev-cert-status",
    funcStatus: "func-status",
    dotnetStatus: "dotnet-status",
    testToolStatus: "test-tool-status",
});
var TelemetryDepsCheckStatus;
(function (TelemetryDepsCheckStatus) {
    TelemetryDepsCheckStatus["success"] = "success";
    TelemetryDepsCheckStatus["warn"] = "warn";
    TelemetryDepsCheckStatus["failed"] = "failed";
})(TelemetryDepsCheckStatus = exports.TelemetryDepsCheckStatus || (exports.TelemetryDepsCheckStatus = {}));
var TelemetryDevCertStatus;
(function (TelemetryDevCertStatus) {
    TelemetryDevCertStatus["Disabled"] = "disabled";
    TelemetryDevCertStatus["AlreadyTrusted"] = "already-trusted";
    TelemetryDevCertStatus["Trusted"] = "trusted";
    TelemetryDevCertStatus["NotTrusted"] = "not-trusted";
})(TelemetryDevCertStatus = exports.TelemetryDevCertStatus || (exports.TelemetryDevCertStatus = {}));
const toolsInstallDescription = () => localizeUtils_1.getLocalizedString("driver.prerequisite.description");
exports.toolsInstallDescription = toolsInstallDescription;
exports.Summaries = Object.freeze({
    devCertSuccess: (trustDevCert) => trustDevCert
        ? localizeUtils_1.getLocalizedString("driver.prerequisite.summary.devCert.trusted.succuss")
        : localizeUtils_1.getLocalizedString("driver.prerequisite.summary.devCert.notTrusted.succuss"),
    devCertSkipped: () => localizeUtils_1.getLocalizedString("driver.prerequisite.summary.devCert.skipped"),
    funcSuccess: (binFolders) => binFolders && (binFolders === null || binFolders === void 0 ? void 0 : binFolders.length) > 0
        ? localizeUtils_1.getLocalizedString("driver.prerequisite.summary.func.installedWithPath", binFolders === null || binFolders === void 0 ? void 0 : binFolders[0])
        : localizeUtils_1.getLocalizedString("driver.prerequisite.summary.func.installed"),
    dotnetSuccess: (binFolders) => binFolders && binFolders.length > 0
        ? localizeUtils_1.getLocalizedString("driver.prerequisite.summary.dotnet.installedWithPath", binFolders[0])
        : localizeUtils_1.getLocalizedString("driver.prerequisite.summary.dotnet.installed"),
    testToolSuccess: (binFolders) => binFolders && (binFolders === null || binFolders === void 0 ? void 0 : binFolders.length) > 0
        ? localizeUtils_1.getLocalizedString("driver.prerequisite.summary.testTool.installedWithPath", binFolders === null || binFolders === void 0 ? void 0 : binFolders[0])
        : localizeUtils_1.getLocalizedString("driver.prerequisite.summary.testTool.installed"),
});
//# sourceMappingURL=constant.js.map